export  const TrendingData = [
    {
        id: 1,
        name: "Maruti Suzuki",
        image: 'https://images.pexels.com/photos/2526128/pexels-photo-2526128.jpeg?auto=compress&cs=tinysrgb&w=400',
        price: '$920',
    },
    {
        id: 2,
        name: "TATA",
        image: 'https://images.pexels.com/photos/1079948/pexels-photo-1079948.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
        price: '$1220',
    },
    {
        id: 3,
        name: "Kia",
        image: 'https://images.pexels.com/photos/2062789/pexels-photo-2062789.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
        price: '$780',
    },
    {
        id: 4,
        name: "Honda",
        image: 'https://images.pexels.com/photos/3778769/pexels-photo-3778769.jpeg?auto=compress&cs=tinysrgb&w=400',
        price: '$588',
    },
    {
        id: 5,
        name: "Renault",
        image: 'https://images.pexels.com/photos/1974520/pexels-photo-1974520.jpeg?auto=compress&cs=tinysrgb&w=400',
        price: '$999',
    },
    {
        id: 6,
        name: "Mahindra",
        image: 'https://images.pexels.com/photos/3221159/pexels-photo-3221159.jpeg?auto=compress&cs=tinysrgb&w=400',
        price: '$540',
    },
]